<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="box">
            <div  class="columns ">

                
                <div v-if="tipo=='todos'" class="column is-2">                
                    <b-field>
                        <b-input :placeholder="$t('SISTEMA.CODIGO')"
                                v-model="codigoExterno"
                                type="number"
                                    icon="magnify"
                                @input="loadAsyncData()">
                        </b-input>
                    </b-field>                
                </div>                   
                
          
                <div class="column is-3">
                    <b-field>
                        <b-input :placeholder="$t('GUIALIST.BUSCARGUIASNOME')"
                                v-model="procurar"
                                icon="magnify"
                                @input="loadAsyncData()"></b-input>
                    </b-field>
                </div>  
                
                <div class="column is-3">
                    <b-field>
                        <b-select v-if="tipo=='todos'" v-model="statusFiltro" :placeholder="$t('SISTEMA.STATUS')"  @input="loadAsyncData()" expanded>
                            <option :value="null"></option>
                            <template v-for="(item, index) in this.StatusGuia">
                                <option  v-bind:key="index" :value="item.valor">
                                    {{item.descricao }}
                                </option>
                            </template>
                        </b-select>                                
                    </b-field>
                </div>                  
                
            
            </div>



            
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                  :bordered="true"
                 :paginated=" (tipo=='todos')"
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGINAANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGINAATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 :row-class="(row, index) => verificaAtraso(row) "
                 @sort="onSort">

            <template >
                <b-table-column  v-slot="props" field="Id" :label="$t('SISTEMA.CODIGO')"  >

                    {{ props.row.clienteCodigoExterno }}

                        <b-icon v-if="props.row.dataHoraCancelado !=null"
                                        icon="close-circle"
                                        size="is-small"                                    
                                        :title="$t('GUIALIST.ATENDIMENTOCANCELADO')"
                                        type="is-danger"></b-icon>
                    
                        <b-icon  v-if="props.row.dataHoraConcluido !=null" icon="trophy"
                                size="is-small"                                    
                                :title="$t('GUIALIST.ATENDIMENTOCOMPLETOFINALIZADO')"
                                type="is-warning"></b-icon>                           
                                                                           

                </b-table-column>    

                <b-table-column  v-slot="props" field="Contrato" :label="$t('SISTEMA.CODIGOCONTRATO')"   >

                    {{ props.row.codigoContrato }}
                 

                </b-table-column> 
                
                <b-table-column  v-if=" tipo == 'emandamento'  || tipo== 'todos'  || tipo== 'instalacaofutura' "   v-slot="props" field="ClienteNome" :label="$t('SISTEMA.CLIENTE')" sortable  >                                                           
                        {{ props.row.clienteNome }}                        
                </b-table-column>                   

                                                        
                <b-table-column v-if="tipo == 'emandamento' || tipo== 'todos' || tipo== 'instalacaofutura'"   v-slot="props" field="ResponsavelTecnico" :label="$t('ASTECS.RESPONSAVELTECNICO')"  >
                    {{ props.row.funcionarioInstaladorNome ? props.row.funcionarioInstaladorNome.toUpperCase() : '' }}
                </b-table-column>                

                <b-table-column v-if="tipo == 'todos'  " v-slot="props" field="DataDeEmissao" :label="$t('GUIALIST.EMISSAO')"  >
                    {{ $moment(props.row.dataHoraCadastro).format("DD/MM/YYYY HH:mm") }}
                </b-table-column>

                <b-table-column v-if="tipo == 'instalacaofutura'"   v-slot="props" field="Faturado" :label="$t('GUIALIST.FATURADO')"  >
                    
                    <span  v-if="!props.row.faturado">
                        <b-switch  :disabled="props.row.faturado" v-model="props.row.faturado" @input="confirmarFaturamento(props.row)"   ></b-switch>
                    </span>
                    <span v-else>
                        <b-switch  :disabled="props.row.faturado" v-model="props.row.faturado"  ></b-switch>
                    </span>                    
                    
             
                </b-table-column>                 

                <b-table-column  v-if="tipo == 'instalacaofutura'" v-slot="props" field="Prazos" :label="$t('GUIALIST.PRAZOS')"  >                                    
                 
                    <small v-if="props.row.posics && props.row.posics.length>0 && props.row.posics[0]!=null " style="margin-top: -5px !important;display: block; font-size: 0.7em;">
                        <b>PRAZO FÁBRICA 1: </b> 
                        <span v-if="props.row.posics[0].dataHoraPrevisao !=null">
                            {{$moment(props.row.posics[0].dataHoraPrevisao).format("DD/MM/YYYY") }}                                                       
                        </span>                                                     
                                                                      
                    </small>  
                    <small v-if="props.row.posics &&  props.row.posics.length>0 && props.row.posics[1]!=null "  style="margin-top: -5px !important;display: block; font-size: 0.7em;">
                        <b>PRAZO FÁBRICA 2: </b> 
                        <span v-if="props.row.posics[1].dataHoraPrevisao !=null">
                            {{$moment(props.row.posics[1].dataHoraPrevisao).format("DD/MM/YYYY") }}                                                       
                        </span>                              
                                                                      
                    </small>
                    <small>
                        <span>                                                              
                                <a  class="has-text-info" @click="visualizarPosics(props.row)" :title="$t('GUIALIST.VISUALIZARPOSICS')">
                                    <b-icon  icon="eye" size="is-small"></b-icon> Ver Todos
                                </a>                                 
                        </span>
                    </small>                          
                                                                                              
                </b-table-column>                 
                                            
                                                    
                <b-table-column  v-slot="props" custom-key="actions" numeric >
                   
                    <router-link v-if="tipo == 'emandamento' || tipo== 'todos' "  :to="{ name: 'guia-astec', params: { id: props.row.id}}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link> 
    
                    <b-button v-if=" tipo=='instalacaofutura'"  
                        title="Editar"
                        class="is-small is-primary"
                        @click="incluirOcorrencia(props.row)" 
                        icon-left="pencil"></b-button>                                                                   
                                                                                                                                                              
                </b-table-column>
                
            </template>
                                  
        </b-table>

        <nav class="level">
                <div class="level-item">
                    <p class="buttons">
                        <b-button type="is-danger"
                                  native-type="button"
                                  icon-left="close-circle"
                                  @click="$router.back();">
                            {{$t('SISTEMA.VOLTAR')}}
                        </b-button>
                         
                    </p>
                </div>
            </nav>        
    </section>
</template>



<style scoped>
    .has-background-dark {
        background-color: #363636d6 !important;
    }

     


</style>

<script>
    import titlebar from '@/components/titlebar.vue'
    import debounce from 'lodash/debounce'
    import modalCadastroOcorrenciasAstec from '@/components/astecs/modalCadastroOcorrenciasAstec.vue' 
    import moment from 'moment'
    import modalListarPosicsOcorrenciasAstec from '@/components/astecs/modalListarPosicsOcorrenciasAstec.vue'

    import { mapState, mapGetters } from 'vuex'

    export default {
        data(){
            return {
                model: [],
                total: 0,
                loading: false,
                clienteId: this.$route.query.clienteId,                                       
                procurar: this.$route.query.procurar ?? null,
                tipo: this.$route.query.tipo ?? 'todos',                                            
                ordenarPor: '',
                ordenar: '',
                defaultOrdenar: '',
                page: 1,
                perPage: 20,                
                id: null,            
                codigoExterno:null,
                dataFiltro: 'cadastro',   
                StatusGuia:[],    
                statusFiltro:null,                   
            }
        },
        components: {
            titlebar            
        },
        computed: {
            titleStack() {
                return [
                    this.$t('SISTEMA.ASTECS'),this.retornarTitleStack(),                    
                ]
            },
            ...mapState([
                'unidadeId',
                'usuario'
            ]),
            ...mapGetters([
                'isInRole'
            ])            
        },
        watch: {            
            unidadeId: function(novaUnidade) {                 
                this.loadAsyncData();
                this.filtroTodos = false;                                                
            },
            datas: function() {                 
                this.loadAsyncData()                                                                
            },
            dataFiltro: function() {                 
                this.loadAsyncData();                
            },            
        },         
        methods: { 



            confirmarFaturamento(row){
                this.$buefy.dialog.confirm({
                    title: this.$t('SISTEMA.ATENCAO'),
                    message: this.$t('ASTECS.MENSAGEMCONFIRMARFATURAMENTOOCORRENCIA'),
                    cancelText: 'Não',
                    confirmText: 'Sim', 
                    type:"is-info",                      
                    hasIcon: true,                                         
                    onConfirm: () => {   

                        this.salvandoDados=true;
                        const params = [];                    
                        params.push(`id=${row.id}`);                                                                                    
                                            
                        this.$http.get(`/api/astecs/ConfirmarFaturar?${params.join('&')}`)
                        .then((res) => {
                            this.salvandoDados=false;
                        }).finally(() => {                                
                            this.salvandoDados=false;
                            this.$router.back();      
                        });                          
                            
                    },
                    onCancel: () => {   
                        row.faturado = false;                                                                     
                        this.salvandoDados = false;    
                    },
                })                  
                
                return true;
            }, 

            visualizarPosics(ocorrencia){

                this.$buefy.modal.open({
                    parent: this,
                    component: modalListarPosicsOcorrenciasAstec,
                    props: {
                        ocorrencia: ocorrencia                      
                    },
                    events: {
                        loadData: this.loadAsyncData,                        
                    },                    
                    hasModalCard: true,
                    trapFocus: true                    
                })

            },         

            carregarAstecs(){
                this.loadAsyncData();
            },      
            incluirOcorrencia(item){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCadastroOcorrenciasAstec,
                    props: {
                        id: item.id,
                        clienteCodigoExterno: item.clienteCodigoExterno,
                        astecId: item.astecId                    
                    },
                    events: {
                        carregarAstecs: this.carregarAstecs,
                    },                    
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:true
                })
            },       
                    
            retornarTitleStack(){
                if(this.tipo == "emandamento" ){
                    return this.$t('ASTECS.LISTAREMANDAMENTO');
                }else if(this.tipo == "instalacaofutura" ) {
                    return this.$t('ASTECS.INSTALACAOFUTURA');
                }else{
                    return this.$t('ASTECS.LISTARTODOS');
                }

                    
            },
            verificaAtraso(row){
                return false

            },
  
            loadAsyncData: debounce(function () {

                const params = this.montaParametros();
                    
                this.loading = true;

                let url = `/api/astecs/procurar?${params.join('&')}`;

                if(this.tipo == "emandamento" ){
                    url= `/api/astecs/procurarEmAndamento?${params.join('&')}`;
                }else if(this.tipo == "instalacaofutura" ){
                    url= `/api/astecs/procurarInstalacaoFutura?${params.join('&')}`;
                }

                this.$http.get(url)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.total = this.perPage * data.pageCount;
                        this.loading = false;
                        this.$router.replace({query: {procurar: this.procurar, page: this.page, tipo: this.tipo }});                      
          
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    }).finally(() => {                        
                        this.clienteId = null;
                    }); 
                                       
            }, 500),

            montaParametros(){
                const params = [                                        
                    `unidadeId=${this.unidadeId}`,                                        
                    `page=${this.page}`
                ];

                if(this.ordenarPor && this.ordenar)
                    params.push(`ordem=${this.ordenarPor}.${this.ordenar}`);                    

                if (this.procurar != null && this.procurar.length>=3) {                    
                    params.push(`nome=${this.procurar}`);                    
                }

                if (this.codigoExterno != null) 
                    params.push(`codigoExterno=${this.codigoExterno}`);     
                
                
                if (this.statusFiltro != null) 
                    params.push(`status=${this.statusFiltro}`);                      



                return params;
            }  ,         
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {                
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },

            carregarStatus(){


                this.$http.get('/api/search/ListarStatusGuiaAstecFiltro')
                .then(res => res.data)
                .then(data => {
                    if (data != null) {
                        this.StatusGuia = data;
                    }
                });
                

            },            
  
            
        
                        
        },

            
        async mounted() {
            await this.carregarStatus();
            await this.loadAsyncData();
            
        }
    }
</script>